export var RenderClearFlag;
(function (RenderClearFlag) {
    RenderClearFlag[RenderClearFlag["Nothing"] = 0] = "Nothing";
    RenderClearFlag[RenderClearFlag["Color"] = 1] = "Color";
    RenderClearFlag[RenderClearFlag["Depth"] = 2] = "Depth";
    RenderClearFlag[RenderClearFlag["Stencil"] = 4] = "Stencil";
})(RenderClearFlag || (RenderClearFlag = {}));
